import { Button, DataSource, HorizontalSpacer, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutClientLicenseUtility extends Layout {
    buttonClean: Button;
    buttonClose: Button;
    buttonRefresh: Button;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    labelLicensesAdmin: Label;
    labelLicensesAdminValue: Label;
    labelLicensesTotal: Label;
    labelLicensesTotalValue: Label;
    labelLicensesUsed: Label;
    labelLicensesUsedValue: Label;
    sourceClientRegistration: DataSource;
    tableClientLicenseUtility: Table;
}
